import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl:{
    width: '100%',
    fontSize:'1rem',
    border:'1px solid #ccc',
    padding: '2px 0px',
    borderRadius: '5px',
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      border:'0px solid #ccc',
    },
    "& .MuiSelect-icon":{
      color:'#ccc',
      marginRight:'20px'
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingLeft:'11px'
    }
  },
  selectControl: {
    "&:before": {
      border:'0'
    },
    "&:after": {
      border:'0'
    },
    "&.MuiSelect-icon":{
      color:'#ccc'
    }
  },
  
  checkBox: {
    height: '1rem',
    width: '1rem',
    border: '1px solid #808080',
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '3px',
    "& .checked":{
        height: '.5rem',
        width: '.5rem',
        border: '1px solid #4c7cfd',
        borderRadius: '50%',
        background: '#4c7cfd',
    },
    "& .intermediate":{
        height: '2px',
        width: '.6rem',
        background: '#4c7cfd',
    }
  },

  selectAllText: {
    fontWeight: 500
  },
  selectedAll: {
    backgroundColor: "#ccc",
    "&:hover": {
      backgroundColor: "#ccc"
    }
  },
  listItemText: {
    fontSize: '1rem',
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};

export { useStyles, MenuProps};